export default __webpack_public_path__ + "static/media/chevron-up.9d50f3ca.svg";